import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';

export const validateFileAndSendReport = createAsyncThunk('selfCareUploadFile/uploadFile', async (data) => {
  try {
    await ProviderManager.getProviderData('uploadFile', [data.extension.toUpperCase(),
       data.converted, data.token, data.action , data.mail,data.fileName, data.orgId]);
    return { error: false};

  } catch (error) {
      return {error: true}
  }
});
const initialState ={
  isLoading: false,
  error: false
}
const selfCareUploadFileSlice = createSlice({
  name: 'selfCareUploadFile',
  initialState: initialState,
  extraReducers: {
    [validateFileAndSendReport.pending]: (state, action) => {
       return {...state, error : false , isLoading :true }
    },
    [validateFileAndSendReport.fulfilled]: (state, action) => {
      if(action.payload.error)
       return {...state, error : true , isLoading :false}
      return {...state, error : false, isLoading :false}
    },
  }
});

export const {changeHandler, validateHandler, resetState} = selfCareUploadFileSlice.actions;

export default selfCareUploadFileSlice.reducer;
